// extracted by mini-css-extract-plugin
export default {"ownerGroupToggle":"NewHotel_ownerGroupToggle__iIkuP","wrapper":"NewHotel_wrapper__nAmBA","formError":"NewHotel_formError__bvuz8"};